import axios from "axios";
import { Contact } from "../../ContactManager/model/contact";
import { SearchParams } from "../../OrganizationManager/model/organization";
import { AddChildOrganizationsParams, AddContactsParams, DeleteMode, Organization } from "../model/organization";

export const fetchOrganizations = async (): Promise<Organization[]> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    const res = await axios.get<Organization[]>(url + "Organizations/List");
    return res.data;
};

export const searchOrganizations = async (params: SearchParams): Promise<any> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    const res = await axios.get<Organization[]>(url + "Organizations/Search", { params });
    return {
        ...res.data,
        ...params,
    };
};

export const updateOrganization = async (organization: Organization): Promise<any> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    await axios.post<any>(url +"Organizations/AddOrUpdate", organization);
};

export const deleteOrganizations = async (organizationIds: string[], mode: DeleteMode): Promise<any> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    await axios.delete<any>(url + `Organizations/Delete?mode=${mode}`, { data: organizationIds });
};

export const fetchOrganizationById = async (orgId?: string): Promise<Organization> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    const res = await axios.get<Organization>(url + `Organizations/Get${orgId ? "?organizationId=" + orgId : ""}`);
    return res.data;
};

export const fetchContactsInOrganization = async (orgId: string): Promise<Contact[]> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    const res = await axios.get<Contact[]>(url + "Organizations/GetContactsInOrganization?organizationId=" + orgId);
    return res.data;
};

export const AddContactsToOrganization = async (params: AddContactsParams): Promise<any> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    await axios.post<any>(url + "Organizations/AddContactsToOrganization", params);
};

export const fetchChildOrganizations = async (parentOrganizationId: string): Promise<Organization[]> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    const res = await axios.get<Organization[]>(
        url + "Organizations/GetChildOrganizations?organizationId=" + parentOrganizationId
    );
    return res.data;
};

export const addChildOrganizationsToOrganization = async (params: AddChildOrganizationsParams): Promise<any> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    await axios.post<any>(url + "Organizations/AddChildOrganizationsToOrganization", params);
};
